import React from 'react'
import Select from './select'

export const render_field = field => {
  const { meta: { touched, error } } = field
  const className = `form-group ${touched && error ? 'red-text' : ''}`

  return (
    <div className={className} style={{ flex: 1 }}>
      <label>{field.label}</label>
      {
        field.type === 'select'
          ? <Select
            options={field.options}
            onChange={field.input.onChange}
            defaultValue={field.defaultValue}
            value={field.value} />
          : <div>
            <input
              style={touched && error ? { borderColor: '#F00' } : {}}
              id={field.id}
              value={field.value}
              type={field.type}
              placeholder={touched && error ? error : field.placeholder}
              onChange={field.onChange}
              {...field.input} />
          </div>
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/utils/renderField.js